// extracted by mini-css-extract-plugin
export default {"scalebar-container":"NZG35A9r_yEf_MNQWlai","scalebar-svg":"oEUsEvTKJJjXMIa4pk0Q"};